import * as React from "react";
import {resourcesHelper} from "@falcon/services";

export class NCDImpactedClaimBanner extends React.Component<{}> {

    public render(): React.ReactNode {
        return (
            <div className="banner">
                <img src={`/${resourcesHelper.THEME}/img/Flow-info.svg`} alt="Blue info icon"/>
                <div className="banner-text">
                    <p><span className="font-weight-bold">Heads up</span> - Your policy is cancelled, but due to the claim you've made we will
                        continue to collect the remaining monthly payments in line with your T&C's</p>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/banners/NCDImpactedClaimBanner.tsx